var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.291)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.784,0H0V6.784H6.784ZM5.427,5.427H1.357V1.357h4.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1,
    height: 1,
    transform: "translate(3 2.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M352,0V6.784h6.784V0Zm5.427,5.427h-4.07V1.357h4.07Z",
    transform: "translate(-337.075)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1,
    height: 1,
    transform: "translate(18 2.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,358.784H6.784V352H0Zm1.357-5.427h4.07v4.07H1.357Z",
    transform: "translate(0 -337.075)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1,
    height: 1,
    transform: "translate(3 17.709)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3,
    height: 2,
    transform: "translate(11 -0.291)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M194.714,36.07h1.357V34.714h1.357V33.357h-4.07V32H192v2.714h2.714Z",
    transform: "translate(-183.859 -30.643)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1,
    height: 1,
    transform: "translate(8 5.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M197.427,160H196.07v1.357H192v1.357h5.427Z",
    transform: "translate(-183.859 -153.216)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.357,196.07H2.714v-1.357H1.357V192H0v5.427H1.357Z",
    transform: "translate(0 -183.859)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1,
    height: 2,
    transform: "translate(3 7.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M100.07,197.427h2.714V196.07h-1.357v-1.357H98.714V192H97.357v2.714H96v2.714h1.357V196.07h2.714Z",
    transform: "translate(-91.93 -183.859)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2,
    height: 3,
    transform: "translate(12 10.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M196.07,352H192v1.357h2.714v4.07H192v1.357h4.07v-1.357h2.714V356.07H196.07Z",
    transform: "translate(-183.859 -337.075)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1,
    height: 1,
    transform: "translate(8 17.709)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1,
    height: 3,
    transform: "translate(14 14.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M388.07,416H384v4.07h1.357v-2.714h2.714Z",
    transform: "translate(-367.718 -398.361)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3,
    height: 1,
    transform: "translate(19 20.709)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2,
    height: 2,
    transform: "translate(20 14.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M353.357,292.07h1.357V288H352v1.357h1.357Z",
    transform: "translate(-337.075 -275.789)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M356.07,193.357h-1.357V192h-1.357v1.357H352v1.357h5.427v-1.357h1.357V192H356.07Z",
    transform: "translate(-337.075 -183.859)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3,
    height: 1,
    transform: "translate(19 12.709)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoQrCode);
export default __webpack_public_path__ + "static/media/ico-qr-code.b83542c8.svg";
export { ForwardRef as ReactComponent };